var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdjustments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.00098C3.63181 6.00098 3.33333 6.29945 3.33333 6.66764C3.33333 7.03583 3.63181 7.33431 4 7.33431C4.36819 7.33431 4.66667 7.03583 4.66667 6.66764C4.66667 6.29945 4.36819 6.00098 4 6.00098ZM2 6.66764C2 5.56307 2.89543 4.66764 4 4.66764C5.10457 4.66764 6 5.56307 6 6.66764C6 7.77221 5.10457 8.66764 4 8.66764C2.89543 8.66764 2 7.77221 2 6.66764Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.00098C4.36819 2.00098 4.66667 2.29945 4.66667 2.66764V5.33431C4.66667 5.7025 4.36819 6.00098 4 6.00098C3.63181 6.00098 3.33333 5.7025 3.33333 5.33431V2.66764C3.33333 2.29945 3.63181 2.00098 4 2.00098ZM4 7.33431C4.36819 7.33431 4.66667 7.63279 4.66667 8.00098V13.3343C4.66667 13.7025 4.36819 14.001 4 14.001C3.63181 14.001 3.33333 13.7025 3.33333 13.3343V8.00098C3.33333 7.63279 3.63181 7.33431 4 7.33431Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.001C7.63181 10.001 7.33333 10.2995 7.33333 10.6676C7.33333 11.0358 7.63181 11.3343 8 11.3343C8.36819 11.3343 8.66667 11.0358 8.66667 10.6676C8.66667 10.2995 8.36819 10.001 8 10.001ZM6 10.6676C6 9.56307 6.89543 8.66764 8 8.66764C9.10457 8.66764 10 9.56307 10 10.6676C10 11.7722 9.10457 12.6676 8 12.6676C6.89543 12.6676 6 11.7722 6 10.6676Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.00098C8.36819 2.00098 8.66667 2.29945 8.66667 2.66764V9.33431C8.66667 9.7025 8.36819 10.001 8 10.001C7.63181 10.001 7.33333 9.7025 7.33333 9.33431V2.66764C7.33333 2.29945 7.63181 2.00098 8 2.00098ZM8 11.3343C8.36819 11.3343 8.66667 11.6328 8.66667 12.001V13.3343C8.66667 13.7025 8.36819 14.001 8 14.001C7.63181 14.001 7.33333 13.7025 7.33333 13.3343V12.001C7.33333 11.6328 7.63181 11.3343 8 11.3343Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.00098C11.6318 4.00098 11.3333 4.29945 11.3333 4.66764C11.3333 5.03583 11.6318 5.33431 12 5.33431C12.3682 5.33431 12.6667 5.03583 12.6667 4.66764C12.6667 4.29945 12.3682 4.00098 12 4.00098ZM10 4.66764C10 3.56307 10.8954 2.66764 12 2.66764C13.1046 2.66764 14 3.56307 14 4.66764C14 5.77221 13.1046 6.66764 12 6.66764C10.8954 6.66764 10 5.77221 10 4.66764Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.00098C12.3682 2.00098 12.6667 2.29945 12.6667 2.66764V3.33431C12.6667 3.7025 12.3682 4.00098 12 4.00098C11.6318 4.00098 11.3333 3.7025 11.3333 3.33431V2.66764C11.3333 2.29945 11.6318 2.00098 12 2.00098ZM12 5.33431C12.3682 5.33431 12.6667 5.63279 12.6667 6.00098V13.3343C12.6667 13.7025 12.3682 14.001 12 14.001C11.6318 14.001 11.3333 13.7025 11.3333 13.3343V6.00098C11.3333 5.63279 11.6318 5.33431 12 5.33431Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustments);
export default __webpack_public_path__ + "static/media/adjustments.92cbd7f496242d5392e7d42769b1e566.svg";
export { ForwardRef as ReactComponent };